import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [贵族首页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=132048764
export const homepage = createAsyncThunk(
  '/live/aristocracy/homepage',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<InitialStateType>>(
      '/live/aristocracy/homepage',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// [购买贵族接口] http://wiki.xunlei.cn/pages/viewpage.action?pageId=132044466
export const buy_aristocracy = createAsyncThunk(
  '/live/aristocracy/buy_aristocracy',
  async (
    arg: {
      level: number //	贵族等级
      to_mid: number //	实际收到贵族的mid
      from: string
    },
    store: any
  ) => {
    const resp = await http.post<
      HiyaRes<{status: number; buy_vip_dmk: any; buy_mystery_dmk: any}>
    >('/live/aristocracy/buy_aristocracy', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
export enum RenewEnum {
  非续费 = 0,
  是续费 = 1,
}
export enum StatusEnum {
  未开通 = -1,
  未生效 = 0,
  已过期 = 1,
  生效中 = 2,
  保护期 = 3,
}
export enum FromEnum {
  vip主页 = 1,
  直播间 = 2,
  贵族主页 = 3,
  用户点击 = 4,
}
export interface privilege {
  id: number //	权益id
  title: string //	标题
  icon: string //	图标
  desc: string //	描述	点击弹出详情的时候使用
  image: string //	特权介绍	可能是动图
  scheme: string //	跳转链接
}
export interface InitialStateType {
  user_info?: {
    name: string
    avatar: string
    level: number
    mid: number
    is_experience: boolean // 是否是体验贵族
  }
  image_privilege_map?: {
    [key: number]: privilege[]
  }
  icon_privilege_map?: {
    [key: number]: privilege[]
  }
  level_info?: {
    coins: number //	原价
    back_coins: number //	返还金币
    renew_coins: number //	续费的价格
    renew_back_coins: number //	续费返还金币
    is_renew: RenewEnum //	0 不是续费 1 是续费
    is_vip_limit: boolean //	是否没达到vip限制
    is_level_limit: boolean //		是否卡级
    is_role_limit: boolean //	是否卡身份
    status: StatusEnum //	-1 默认值 0 未生效 1 已过期 2 生效中 3 保护期
    et: string //	生效中的话存在的到期时间
    honor: number //	等级对应的荣誉值
    level: number
    is_limit_discount: boolean // 是否是限时折扣
    discount?: number // 折扣百分数
  }[]
  toast?: string
  countdown?: number // 倒计时秒数
  discount_level?: number // 折扣定位等级
  ari_discount_popup?: boolean // 贵族折扣是否弹窗
  renewal_popup?: {
    // 贵族续费弹窗
    title_img: string // 弹窗标题多语图片
    discount: number // 折扣
    discount_msg: string // 折扣msg
    free: number // free百分比
    free_msg: string // free msg
  }
}

const initialState: InitialStateType = {}

export const LordSlice = createSlice({
  name: 'LordSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default LordSlice.reducer
export const LordActions = LordSlice.actions

export const useLordState = () => {
  const data = useSelector((state) => {
    return state.Lord
  })
  return data
}
